//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React, { ReactElement } from 'react'
import { Box, Tooltip, Typography } from '@mui/material'
import ViewItem from './ViewItem'
import { ethValueDisplay } from '@shared/conversions'

export default function ViewEthString(props: { value: string; label: string; inTable: boolean }): ReactElement {
  const { value, inTable, label } = props

  const displayValue = ethValueDisplay(value)
  if (inTable) {
    return (
      <React.Fragment>
        <Tooltip title={value}>
          <Typography variant="bodyBold" gutterBottom component="div">
            {displayValue}
          </Typography>
        </Tooltip>
      </React.Fragment>
    )
  }
  return (
    <ViewItem>
      <Typography variant="bodyMuted" gutterBottom component="div">
        {label}
      </Typography>
      <Tooltip
        title={
          <Box
            sx={{
              display: 'flex',
              width: 350,
              flexDirection: 'column',
              border: '1px solid #dadde9',
            }}
          >
            <Typography variant="caption" color="inherit">
              {' '}
              {value}
            </Typography>
          </Box>
        }
      >
        <Typography variant="bodyBold" gutterBottom component="div">
          {displayValue}
        </Typography>
      </Tooltip>
    </ViewItem>
  )
}
